<template>
  <v-dialog v-model="modelFolheto" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="folheto != null" class="bg-white">
      <v-card-text class="pa-4">
        <embed width="100%" :height="height + 'px'" name="plugin" :src="folheto.pdf">
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogFolheto',
  data(){
    return {
      modelFolheto: false,
      height: window.innerHeight - 80
    }
  },
  props: {
    folheto: {
      type: Object,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  watch: {
    model() {
      this.modelFolheto = this.model
    }
  }
}
</script>